import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';

export const ButtonWrapper = styled.div`
    width: 100%;
    ${mediaQuery.minimum('normal')} {
        width: 200px;
    }
`;
